module.exports = __webpack_public_path__ + "static/media/28.d2f8f0a8.jpeg";